import { cva } from "class-variance-authority";
import React from "react";

import { cn } from "@/lib/chillnn/cn";

import type { VariantProps } from "class-variance-authority";

const dotVariants = cva("rounded-full", {
	variants: {
		variant: {
			blue: "bg-edited",
			red: "bg-not-entered",
			black: "bg-zinc-900",
		},
		size: {
			default: "h-2 w-2",
		},
	},
	defaultVariants: {
		variant: "blue",
		size: "default",
	},
});

export interface DotProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof dotVariants> {}

const Dot = React.forwardRef<HTMLDivElement, DotProps>(({ className, variant, size, ...props }, ref) => {
	return <div className={cn(dotVariants({ variant, size, className }))} ref={ref} {...props} />;
});
Dot.displayName = "Dot";

export { Dot, dotVariants };
